import { getDriverSpecialties } from './driverSpecialties';
import { normalizeDriverLevel } from './driverLevel';

/**
 * hrFilters — filtres de l'onglet Équipe (catégorie / niveau / disponibilité)
 * et de l'onglet Recrutement (salaire / niveau / spécialité). Fonctions pures.
 */
export const TEAM_AVAILABILITY_OPTIONS = [
  { id: 'all', labelKey: 'hr_filter_all' },
  { id: 'available', labelKey: 'hr_filter_available' },
  { id: 'mission', labelKey: 'hr_filter_mission' },
  { id: 'training', labelKey: 'hr_filter_training' },
  { id: 'absent', labelKey: 'hr_filter_absent' },
];

export const LICENSE_CATEGORIES = ['B', 'C', 'CE'];

export const SALARY_BANDS = [
  { id: 'all', labelKey: 'hr_filter_all', min: 0, max: Infinity },
  { id: 'lt3000', label: '< 3 000 €', min: 0, max: 3000 },
  { id: '3000_4000', label: '3 000 – 4 000 €', min: 3000, max: 4000 },
  { id: '4000_5500', label: '4 000 – 5 500 €', min: 4000, max: 5500 },
  { id: 'gt5500', label: '> 5 500 €', min: 5500, max: Infinity },
];

export const DEFAULT_TEAM_FILTERS = { license: 'all', level: 'all', availability: 'all' };
export const DEFAULT_RECRUIT_FILTERS = { salary: 'all', level: 'all', specialty: 'all' };

export function driverAvailability(d) {
  const s = d.status;
  if (s === 'training') return 'training';
  if (s === 'active' || s === 'returning' || s === 'delivery' || d.assignedVehicleId) return 'mission';
  if (s === 'idle') return 'available';
  return 'absent';
}

export function filterTeam(drivers = [], f = DEFAULT_TEAM_FILTERS) {
  return drivers.filter((d) => {
    if (f.license !== 'all' && !(d.licenses || []).includes(f.license)) return false;
    if (f.level !== 'all' && normalizeDriverLevel(d.level) !== Number(f.level)) return false;
    if (f.availability !== 'all' && driverAvailability(d) !== f.availability) return false;
    return true;
  });
}

export function filterCandidates(candidates = [], f = DEFAULT_RECRUIT_FILTERS) {
  const band = SALARY_BANDS.find((b) => b.id === f.salary) || SALARY_BANDS[0];
  return candidates.filter((d) => {
    const cost = d.employerCost || 0;
    if (cost < band.min || cost >= band.max) return false;
    if (f.level !== 'all' && normalizeDriverLevel(d.level) !== Number(f.level)) return false;
    if (f.specialty !== 'all' && !getDriverSpecialties(d).includes(f.specialty)) return false;
    return true;
  });
}

export function collectSpecialties(candidates = []) {
  const set = new Set();
  candidates.forEach((d) => getDriverSpecialties(d).forEach((s) => set.add(s)));
  return [...set].sort((a, b) => a.localeCompare(b, 'fr'));
}

export const isFilterActive = (f, defaults) => Object.keys(defaults).some((k) => f[k] !== 'all');
